"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createI18nClient = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./types"), exports);
var createI18nClient_1 = require("./createI18nClient");
Object.defineProperty(exports, "createI18nClient", { enumerable: true, get: function () { return tslib_1.__importDefault(createI18nClient_1).default; } });
//# sourceMappingURL=index.js.map